import { Role } from './role';

export class User {
    static serialVersionUID = -8243145429438016234;
    id: string;
    email: string;
    phone_number: string;
    first_name: string;
    last_name: string;
    role: Role;
    user_name: string;
    created_date: Date;
    modified_date: Date;
    current_time: Date;
    organization_id: string;
    status: string;
    contact_preference: User.ContactPreference;
    address:string;

    city:string;

    state:string;

    zip:string;


    paymentPref: any;
    constructor() { }
}
export namespace User {

    export enum ContactPreference {
        NONE = <any>'NONE',
        SMS = <any>'SMS',
        EMAIL = <any>'EMAIL',
        BOTH = <any>'BOTH'
    }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/models/user.model.ts